import { render, staticRenderFns } from "./ResultSampleAnalyteTable.vue?vue&type=template&id=52695b1c"
import script from "./ResultSampleAnalyteTable.vue?vue&type=script&lang=js"
export * from "./ResultSampleAnalyteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports